import { getTypeFilter } from "./constant";

export const ticketsFilter = (ticket, filters) => {
  const arrStatus = Object.keys(filters.status).filter((i) => filters.status[i].selected);
  const arrType = getTypeFilter(Object.keys(filters.type).filter((i) => filters.type[i].selected));

  if (!arrType.length && !arrStatus.length) return true;
  else if (arrType.length && !arrType.includes(ticket.type)) return false;
  else if (arrStatus.length && !arrStatus.includes(ticket.status)) return false;
  else return true;
};
